import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import ConfigUsers from './users/ConfigUsers'
import ConfigCompanies from './companies/ConfigCompanies'
import ConfigGroupsPage from './groups/ConfigGroupsPage'

const ConfigRouter = withRouter(observer(props => {
  const { url } = props.match
  return (
    <Switch>
      <Route exact path={`${url}/usuarios`} render={() => <ConfigUsers />} />
      <Route exact path={`${url}/empresas`} render={() => <ConfigCompanies />} />
      <Route exact path={`${url}/grupos`} render={() => <ConfigGroupsPage />} />
    </Switch>
  )
}))

export default ConfigRouter



// WEBPACK FOOTER //
// ./src/components/dashboard/config/ConfigRouter.js